import Layout from '@/layout/Layout.vue';
import { AUTH_KEYS } from '@/constants';
export default {
  path: '/account',
  component: Layout,
  name: 'Account',
  meta: { title: 'account_information_update', auth: AUTH_KEYS.ACCOUNT_PAGE },
  children: [
    {
      path: '/account',
      component: () => import('@/views/AccountInfoRegister/Index.vue'),
      meta: { title: 'Account Info Update', auth: AUTH_KEYS.ACCOUNT_INFO_REGISTER }
    }
  ]
};
